import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

// Snap scrolling requires the container to have height 100vh and scroll snap align
const SplitSection = ({ title, content, imageSrc, reversed = false, linkTo, extraContent, imagePosition = 'center bottom', imageObjectFit = 'cover', imageStyle = {} }) => {
  return (
    <div className={`split-section ${reversed ? 'reversed' : ''}`}>
      {/* Image Side */}
      <div className="split-image-side">
        {imageSrc ? (
          <img 
            src={imageSrc} 
            alt={title}
            style={{ 
              objectPosition: imagePosition,
              objectFit: imageObjectFit,
              ...imageStyle
            }} 
          />
        ) : (
          <div style={{ padding: '2rem' }}>
            <h2 style={{ fontSize: '4rem', marginBottom: '1rem' }}>{title}</h2>
          </div>
        )}
      </div>

      {/* Text Side */}
      <div className="split-text-side">
        {!imageSrc && (
             // If sticky side had no image, maybe we put image here or just text? 
             null
        )}
        
        <div className="split-content">
            {linkTo ? (
              <Link to={linkTo} style={{ display: 'inline-block', marginBottom: '2rem' }}>
                <motion.div
                  initial="rest"
                  whileHover="hover"
                  animate="rest"
                  style={{ position: 'relative' }}
                >
                  <h2 style={{ fontSize: '3rem', margin: 0 }}>{title}</h2>
                  <motion.span
                    variants={{
                      rest: { width: 0, opacity: 0 },
                      hover: { width: '100%', opacity: 1 }
                    }}
                    transition={{ duration: 0.3 }}
                    style={{
                      position: 'absolute',
                      bottom: -5,
                      left: 0,
                      height: '2px',
                      background: 'currentColor'
                    }}
                  />
                </motion.div>
              </Link>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', marginBottom: '2rem', flexWrap: 'wrap' }}>
                <h2 style={{ fontSize: '3rem', margin: 0 }}>{title}</h2>
                {extraContent}
              </div>
            )}
            <div style={{ fontSize: '1.2rem', lineHeight: '1.8', whiteSpace: 'pre-line' }}>
                {content}
            </div>

        </div>
      </div>
    </div>
  );
};

export default SplitSection;
